export interface TreatmentAutoAssignCandidate {
    readonly userId: string;
    readonly fullName?: string | null;
}

/** One auto-assignment attempt and the full trace of how it decided. */
export interface TreatmentAutoAssignJob {
    readonly id: number;
    readonly treatmentId: string;
    readonly treatmentTinyId?: string | null;
    readonly status: string;
    readonly triggerSource: string;
    /** Always present when `status` is `Skipped`, and only then. */
    readonly skipReason?: string | null;
    readonly selectionStrategy: string;
    readonly resolvedShiftId?: number | null;
    readonly resolvedShiftName?: string | null;
    readonly resolvedShiftDate?: string | null;
    readonly treatmentTypeGroupId?: number | null;
    readonly treatmentTypeGroupName?: string | null;
    readonly matchedRuleId?: number | null;
    readonly matchedRuleName?: string | null;
    readonly matchedRuleScore?: number | null;
    readonly candidates: readonly TreatmentAutoAssignCandidate[];
    readonly targetDesignerId?: string | null;
    readonly targetDesignerName?: string | null;
    readonly assignedDesignerId?: string | null;
    readonly assignedDesignerName?: string | null;
    /** Designer already on the treatment when the job declined to overwrite. */
    readonly observedDesignerId?: string | null;
    readonly observedDesignerName?: string | null;
    readonly errors: readonly string[];
    readonly attemptCount: number;
    readonly startAfter: string;
    readonly succeedDate?: string | null;
    readonly failedDate?: string | null;
    readonly createdDate: string;
}
